import { render, staticRenderFns } from "./userWallet.vue?vue&type=template&id=5c311303&scoped=true&"
import script from "./userWallet.vue?vue&type=script&lang=js&"
export * from "./userWallet.vue?vue&type=script&lang=js&"
import style0 from "./userWallet.vue?vue&type=style&index=0&id=5c311303&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c311303",
  null
  
)

export default component.exports